import { useMemo } from 'react';
import { useScreenTheme } from '../../../../shared/hooks/useScreenTheme';
import { Text, View } from 'react-native';
import { CardProps } from './CardsProps';
import { createCardStyles } from '../../../../shared/components/ui/Cards/Cards.styles';

const Cards = (props: CardProps) => {
  const { title, count, iconName, testID, customContainerStyles, ...rest } = props;

  const theme = useScreenTheme('cards');
  const styles = useMemo(() => createCardStyles(theme), [theme]);

  return (
    <View
      {...rest}
      style={[styles.scoreCard, customContainerStyles]}
      testID={testID}
      focusable={true}
      // @ts-ignore - web-only prop for keyboard tab navigation
      tabIndex={0}>
      {/* <View style={styles.scoreCardBody}> */}
        <Text style={styles.scoreCardTitle}>{title}</Text>
        <Text style={styles.scoreCardCount}>
          {String(count).padStart(2, '0')}
        </Text>
      {/* </View> */}
      {/* {iconName} */}
    </View>
  );
};

export default Cards;
